import * as React from "react"

import { cn } from "../../../lib/utils"

function AdgeLogo({
  collapsed = false,
  className,
  ...props
}: React.ComponentProps<"div"> & { collapsed?: boolean }) {
  return (
    <div
      data-slot="adge-logo"
      data-collapsed={collapsed || undefined}
      className={cn(
        "inline-flex shrink-0 items-center overflow-hidden transition-[width] duration-200",
        collapsed ? "w-[43px]" : "w-[86px]",
        className,
      )}
      style={{ height: 29 }}
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 120 40"
        width={86}
        height={29}
        fill="currentColor"
        aria-label="Adge"
        className={cn(
          "shrink-0 transition-transform duration-200",
          collapsed && "translate-x-[7px]",
        )}
      >
        {/* Chevron */}
        <path d="M35.86,11.26c-7.82,0-14.29,5.82-15.65,13.25h-.29c-1.36-7.42-7.83-13.25-15.65-13.25h-1.08v5.14h1.08c9.19,0,12.33,4.68,13.22,11.85h5.15c.89-7.17,4.03-11.85,13.22-11.85h1.08v-5.14h-1.08Z" />
        {/* Wordmark */}
        <path
          d="M50.8,28.23c-3.59,0-5.83-2-5.83-4.88,0-3.1,2.08-4.86,5.93-4.86h5.83v-.76c0-2.75-1.51-4.15-4.45-4.15-2.48,0-3.86.89-4.34,2.75h-2.59c.51-3.08,3.16-4.91,7.01-4.91,4.37,0,6.8,2.16,6.8,6.12v7.69h1.24v2.7h-2.81v-2.43h-1.13c-1.11,1.65-3.18,2.72-5.66,2.72ZM51.12,26.12c3.08,0,5.61-2.16,5.61-4.8v-.89h-5.64c-2.48,0-3.75.97-3.75,2.81s1.43,2.89,3.78,2.89ZM70.28,28.25c-4.77,0-7.61-3.18-7.61-8.42s2.81-8.42,7.39-8.42c2.64,0,4.67,1.08,5.66,3.08h.11V5.27h2.54v19.96h1.35v2.7h-2.81v-2.43h-1.13c-1.08,1.81-2.91,2.75-5.5,2.75ZM70.64,26.1c3.13,0,5.21-1.94,5.21-4.94v-2.64c0-2.99-2.08-4.94-5.21-4.94-3.43,0-5.42,2.29-5.42,6.26s2,6.26,5.42,6.26ZM89.61,34.73c-4.34,0-7.26-1.94-7.74-5.18h2.7c.49,1.94,2.21,2.97,5.04,2.97,3.56,0,5.53-1.73,5.53-4.91v-2.75h-.13c-.84,1.94-2.89,3.08-5.48,3.08-4.64,0-7.55-3.18-7.55-8.25s2.91-8.25,7.61-8.25c2.59,0,4.42.94,5.5,2.75h1.13v-2.43h2.81v2.7h-1.35v13.35c0,4.34-2.97,6.93-8.07,6.93ZM90.12,25.72c2.99,0,5.02-1.92,5.02-4.8v-2.48c0-2.89-2.02-4.8-5.02-4.8-3.51,0-5.61,2.24-5.61,6.04s2.1,6.04,5.61,6.04ZM109.42,28.25c-4.96,0-8.15-3.32-8.15-8.47s3.18-8.36,8.04-8.36c4.56,0,7.5,2.97,7.5,7.58v1.13h-13.11c.13,3.72,2.29,5.91,5.69,5.91,2.35,0,4.05-1.03,4.67-2.94h2.59c-.84,3.29-3.48,5.15-7.23,5.15ZM103.84,18.19h10.52c-.24-2.91-2.16-4.61-5.07-4.61s-4.94,1.7-5.45,4.61Z"
          className={cn(
            "transition-opacity duration-200",
            collapsed && "opacity-0",
          )}
        />
      </svg>
    </div>
  )
}

export { AdgeLogo }
